import BasicRouterView from "../../components/BasicRouterView.vue";

const documentosRoutes = {
  path: "doc",
  redirect: { name: "documentos-listar" },
  meta: {
    label: "Documentos",
    icon: "folder",
    show: true,
  },
  component: BasicRouterView,
  children: [
    {
      path: "documento/listar/:vencimentoEmDias?/:status?",
      name: "documentos-listar",
      meta: {
        label: "Listar Documentos",
        icon: "note_add",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/ListarDocumentos.vue"
        ),
    },
    {
      path: "documento/listar-categoria",
      name: "documentos-categoria",
      meta: {
        label: "Listar Categorias",
        icon: "category",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/ListarCategorias.vue"
        ),
    },
    {
      path: "documento/detalhe/:uuid",
      name: "documentos-detalhe",
      meta: {
        label: "",
        icon: "category",
        show: false,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/DetalheDocumento.vue"
        ),
    },
    {
      path: "documento/upload",
      name: "documentos-upload",
      meta: {
        label: "Upload Arquivo",
        icon: "note_add",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/UploadCriacaoMassaDocumentos.vue"
        ),
    },
    {
      path: "documento/optin",
      name: "documentos-optin",
      meta: {
        label: "Config. Alertas",
        icon: "notifications",
        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/DocumentosOptin.vue"
        ),
    },
    {
      path: "documento/criar-origem-documento",
      name: "documentos-criar-origem-documento",
      meta: {
        label: "Criar Origem",
        icon: "input",

        show: true,
      },
      component: () =>
        import(
          /* webpackChunkName: "documentos" */ "./views/CriarOrigemDocumento.vue"
        ),
    },
  ],
};

export default documentosRoutes;
